export const PROPERTY_SPACE_PERSON_fi = {
  translation: {
    actions: {
      createApartment: 'Luo tila',
      bulk: {
        deleteResidentsMessage: 'Haluatko varmasti poistaa {{count}} valittua henkilöä?',
        deleteApartmentsMessage: 'Haluatko varmasti poistaa {{count}} valittua tilaa?',
        deleteCondominiumsMessage: 'Haluatko varmasti poistaa {{count}} valittua kiinteistöä?',
        editResidentsTitle: 'Muokkaa henkilöitä',
        editApartmentsTitle: 'Muokkaa tiloja',
        editCondominiumsTitle: 'Muokkaa kiinteistöjä',
        selectResidentApartment: 'Valitse tila',
      },
    },
    key: {
      handoverAddFromDirectory: 'Kiinteistöstä tai tilasta',
      handoverDirectoryHint:
        'Valitse kiinteistö tai tila, tai kirjoita vähintään kaksi merkkiä hakukenttään (tunniste, osoite, kiinteistö).',
      handoverDirectoryNoQuery: 'Valitse kiinteistö tai tila, tai kirjoita hakua (vähintään 2 merkkiä).',
      handoverAddResident: 'Luo uusi henkilö',
    },
    keys: {
      condominium: 'Kiinteistö',
      apartment: 'Tila',
      handoverInstructions: 'Avainluovutuksen ohjeet',
      handoverInstructionsPlaceholder: 'Kirjoita ohjeet avainten luovutukseen ja palautukseen',
      resident: 'Henkilö',
    },
    common: {
      space: 'Tila',
    },
    apartment: {
      apartments: 'Tilat',
      deleteTitle: 'Poista tila',
      deleteMessage: 'Haluatko varmasti poistaa tämän tilan? Tätä toimintoa ei voi peruuttaa.',
      apartment: 'Tila',
    },
    apartments: {
      title: 'Tilat',
      searchPlaceholder: 'Hae tiloja...',
      editApartment: 'Muokkaa tilaa',
      apartment: 'Tila',
      defaultTitle: 'Tila',
      notFoundDescription: 'Pyydettyä tilaa ei löytynyt tai sinulla ei ole oikeutta tarkastella sitä.',
      residents: 'Henkilöt',
      deleteResidentTitle: 'Poista henkilö',
      deleteResidentMessage: 'Haluatko varmasti poistaa henkilön',
      createNew: 'Luo uusi tila',
      createMultiple: 'Luo useita tiloja',
      multipleLabel: 'Luo useita tiloja',
      multipleDescription: 'Ota käyttöön luodaksesi useita tiloja kerralla numeroalueella',
      condominium: 'Kiinteistö',
      selectCondominium: 'Valitse kiinteistö',
      createMultipleDescription: 'Luo useita tiloja kerralla numeroalueella',
      addResident: 'Lisää henkilö',
      condominiumRequired: 'Kiinteistö on pakollinen',
      residentsCount: 'Henkilöitä',
      showEmptyOnly: 'Vain tilat ilman henkilöitä',
    },
    validation: {
      condominiumRequired: 'Kiinteistö vaaditaan',
      apartmentRequired: 'Tila vaaditaan',
    },
    residents: {
      title: 'Henkilöt',
      searchPlaceholder: 'Hae henkilöitä...',
      editResident: 'Muokkaa henkilöä',
      createResident: 'Luo uusi henkilö',
      apartment: 'Tila',
      apartmentRequired: 'Tila vaaditaan',
      selectApartment: 'Valitse tila',
      noResidentsFound: 'Ei henkilöitä',
      noResidentsWithoutApartment: 'Kaikilla henkilöillä on jo tila',
    },
    wizard: {
      title: 'Kiinteistön pika-luonti',
      subtitle: 'Luo kiinteistö, tilat, henkilöt ja avaimet kerralla',
      steps: {
        condominium: 'Kiinteistö',
        apartments: 'Tilat',
        residents: 'Henkilöt',
      },
      stepDescriptions: {
        condominium: 'Luo uusi kiinteistö täyttämällä perustiedot',
        apartments: 'Lisää tiloja kiinteistöön yksittäin tai massana',
        residents: 'Lisää henkilöitä ja linkitä heidät tiloihin',
      },
      actions: {
        addApartment: 'Lisää tila',
        addResident: 'Lisää henkilö',
      },
      info: {
        noApartmentsForResidents: 'Lisää ensin tilat voidaksesi lisätä henkilöitä.',
      },
      apartmentsList: 'Tilat',
      residentsList: 'Henkilöt',
    },
    general: {
      noApartments: 'Ei tiloja',
      noResidents: 'Ei henkilöitä',
      emptyFilterShort: 'Tyhjät',
      showBulkDelete: 'Näytä massapoisto-taulukoissa',
      showBulkDeleteDescription:
        'Mahdollistaa usean kohteen valinnan ja poiston tiloissa, henkilöissä, kiinteistöissä ja avaimissa.',
    },
    condominiums: {
      apartmentKeyType: 'Tilan avaintyyppi',
    },
    condominium: {
      header: 'Kiinteistöt',
      condominiums: 'Kiinteistöt',
      condominiumDetails: 'Kiinteistön tiedot',
      name: 'Kiinteistö',
      superIntendent: 'Hallinnoija',
      selectSuperIntendent: 'Valitse hallinnoija...',
      create: 'Luo kiinteistö',
      edit: 'Muokkaa kiinteistöä',
      update: 'Päivitä kiinteistö',
      deleteTitle: 'Poista kiinteistö',
      deleteMessage: 'Haluatko varmasti poistaa kiinteistön',
      apartments: 'Tilat',
      searchPlaceholder: 'Hae kiinteistöjä...',
      nocondominiumsForSearch: 'Ei kiinteistöjä haulle "{{searchTerm}}"',
      nocondominiumsYet: 'Ei kiinteistöjä.',
      selectSuperintendent: 'Valitse hallinnoija...',
      apartmentKeyType: 'Tilan avaintyyppi',
      selectCondominium: 'Valitse kiinteistö',
      transfer: {
        toSubCompany: 'Siirrä aliyritykselle',
        transferredTooltip: 'Siirretty aliyritykselle',
        transferredTo: 'Siirretty yritykselle {{name}}',
        subCompanyCanEdit: 'Alayritys voi muokata siirrettyjä tietoja',
        revokeTransfer: 'Peruuta siirto',
        changeEditAccess: 'Muuta muokkausoikeutta',
        selectSubCompany: 'Valitse aliyritys',
        confirmTransfer: 'Vahvista siirto',
        transferSuccess: 'Siirto tehty',
        revokeConfirm: 'Haluatko varmasti peruuttaa siirron? Alayritys menettää pääsyn kiinteistöön.',
        transferredAt: 'Siirretty',
        back: 'Edellinen',
        next: 'Seuraava',
      },
    },
    controlPanel: {
      transferredCondominiums: 'Siirretyt kiinteistöt',
      personalDataPurge: {
        targetsHint: 'Henkilöt on valittu valmiiksi. Kiinteistöt, tilat ja avaimet voi lisätä tarvittaessa.',
        peopleGroupHint: 'Henkilöt, vuokranantajat ja vuokrahakijat.',
        propertyGroupHint: 'Kiinteistöt, tilat ja avaimet siirtyvät samaan 7 päivän roskakoriin.',
        targetTypes: {
          resident: 'Henkilöt',
          condominium: 'Kiinteistöt',
          apartment: 'Tilat',
        },
        fields: {
          condominiumId: 'Kiinteistö',
          apartmentId: 'Tila',
        },
        columns: {
          condominium: 'Kiinteistö',
        },
      },
    },
    messages: {
      selectResident: 'Valitse henkilö',
      apartmentCreated: 'Tila luotu onnistuneesti',
      apartmentsCreated: 'Tilat luotu onnistuneesti',
      apartmentUpdated: 'Tila päivitetty onnistuneesti',
      apartmentDeleted: 'Tila poistettu onnistuneesti',
      apartmentsDeletedBulk: '{{count}} tilaa poistettu onnistuneesti',
      saveApartmentSuccess: 'Tila tallennettu onnistuneesti',
      condominiumCreated: 'Kiinteistö luotu onnistuneesti',
      condominiumUpdated: 'Kiinteistö päivitetty onnistuneesti',
      condominiumDeleted: 'Kiinteistö poistettu onnistuneesti',
      condominiumsDeletedBulk: '{{count}} kiinteistöä poistettu onnistuneesti',
      residentCreated: 'Henkilö luotu onnistuneesti',
      residentUpdated: 'Henkilö päivitetty onnistuneesti',
      residentDeleted: 'Henkilö poistettu onnistuneesti',
      residentsDeletedBulk: '{{count}} henkilöä poistettu onnistuneesti',
      saveResidentSuccess: 'Henkilö tallennettu onnistuneesti',
      apartmentCreateFailed: 'Tilan luonti epäonnistui',
      apartmentsCreateFailed: 'Tilojen luonti epäonnistui',
      apartmentUpdateFailed: 'Tilan päivitys epäonnistui',
      apartmentDeleteFailed: 'Tilan poisto epäonnistui',
      saveApartmentFailed: 'Tilan tallennus epäonnistui',
      condominiumCreateFailed: 'Kiinteistön luonti epäonnistui',
      condominiumUpdateFailed: 'Kiinteistön päivitys epäonnistui',
      condominiumDeleteFailed: 'Kiinteistön poisto epäonnistui',
      residentCreateFailed: 'Henkilön luonti epäonnistui',
      residentUpdateFailed: 'Henkilön päivitys epäonnistui',
      residentDeleteFailed: 'Henkilön poisto epäonnistui',
      saveResidentFailed: 'Henkilön tallennus epäonnistui',
    },
    resident: {
      residentDetails: 'Henkilön tiedot',
      notFound: 'Henkilöä ei löytynyt',
      apartment: 'Tila',
      noApartment: 'Ei tilaa',
      deleteTitle: 'Poista henkilö',
      deleteMessage: 'Haluatko varmasti poistaa henkilön "{{name}}"? Tätä toimintoa ei voi peruuttaa.',
    },
    dashboard: {
      myManagedProperties: 'Hallinnoimani kiinteistöt',
      noProperties: 'Ei näytettäviä kiinteistöjä',
    },
    properties: {
      tabProperties: 'Kiinteistöt',
      tabApartments: 'Tilat',
      tabResidents: 'Henkilöt',
      createProperty: 'Luo kiinteistö',
      createApartment: 'Luo tila',
      createResident: 'Luo henkilö',
      searchApartments: 'Hae tiloja...',
    },
    tooltips: {
      keys: {
        handoverInstructions:
          'Näytetään avainten luovutuksen ja palautuksen yhteydessä. Voit määrittää ohjeet yritys-, laskutus-, kiinteistö- ja tilatasolla; alempi taso ylikirjoittaa ylemmän.',
      },
      wizard: {
        superintendent:
          'Hallinnoija on henkilö, joka vastaa kiinteistön päivittäisestä hallinnasta ja kunnossapidosta.',
      },
      condominium: {
        businessId:
          'Suomalainen Y-tunnus muodossa 1234567-8. Valinnainen, mutta suositeltu virallisille kiinteistöille.',
      },
      apartments: {
        multiple:
          'Luo useita tiloja peräkkäisillä numeroilla (esim. A1, A2, A3). Kaikki tilat jakavat saman perusosoitteen.',
      },
      settings: {
        showMyProperties: 'Näytä kiinteistöt, joissa olet listattu hallinnoijaksi tai sinulla on erikoisoikeudet.',
        showBulkDelete:
          'Mahdollistaa usean kohteen valinnan ja massapoiston taulukoissa (tilat, henkilöt, kiinteistöt, avaimet).',
      },
    },
    import: {
      condominiums: 'Kiinteistöt',
      apartments: 'Tilat',
      residents: 'Henkilöt',
      condominiumsInstructions: 'Tuo kiinteistöjä',
      condominiumsInstructionsDescription: 'Täytä vähintään nimi ja osoitetiedot. Muut kentät ovat valinnaisia.',
      condominiumsFieldSuperIntendent: 'Hallinnoija: Koko nimi (esim. "Matti Meikäläinen")',
      apartmentsInstructions: 'Tuo tiloja',
      apartmentsInstructionsDescription: 'Osoite ja kiinteistö ovat pakollisia tietoja.',
      apartmentsFieldCondominium: 'Kiinteistö: Olemassa olevan kiinteistön nimi',
      keysFieldCondominium: 'Kiinteistö: Olemassa olevan kiinteistön nimi (vain yleisille avaimille)',
      residentsInstructions: 'Tuo henkilöitä',
      residentsInstructionsDescription: 'Nimi, sähköposti ja tila vaaditaan.',
      residentsFieldApartment: 'Tila: Täydellinen osoite muodossa "Katu, Postinumero Kaupunki"',
      errors: {
        superintendentNotFound: 'Ei löytynyt',
        condominiumNotFound: 'Ei löytynyt',
        condominiumRequiredForGeneral: 'Kiinteistö vaaditaan yleisten avainten tyypeille',
        condominiumNotAllowedForNonGeneral: 'Kiinteistöä ei voi määrittää avaimille, jotka eivät ole yleisiä avaimia',
      },
    },
    invitations: {
      condominium: 'Kiinteistö',
      apartment: 'Tila',
      extraPermissions: 'Lisäoikeudet',
      canDoUpkeeps: 'Voi tehdä tarkastuksia',
      canRespondToServiceRequests: 'Voi vastata palvelupyyntöihin',
      canSeeResidents: 'Näkee henkilöt',
      canAccessAllApartments: 'Pääsy kaikkiin kiinteistön tiloihin',
      canAccessAllKeys: 'Pääsy kaikkiin avaimiin',
      canAccessAllServiceRequests: 'Pääsy kaikkiin palvelupyyntöihin',
    },
    contractor: {
      property: 'Kiinteistö',
      apartment: 'Tila',
      selectProperty: 'Valitse kiinteistö',
      selectApartment: 'Valitse tila',
      keyAccessFilterCondominiumPlaceholder: 'Kaikki kiinteistöt',
      keyAccessFilterApartmentPlaceholder: 'Kaikki tilat',
    },
    contractorDashboard: {
      properties: 'Kiinteistöt',
      apartments: 'Tilat',
    },
    documentBank: {
      searchPlaceholder: 'Hae kiinteistöä, tilaa tai asiakkuutta…',
      sections: {
        condominiums: 'Kiinteistöt',
      },
    },
    events: {
      entityType: {
        resident: 'Henkilö',
        apartment: 'Tila',
        condominium: 'Kiinteistö',
        key: 'Avain',
        landlord: 'Vuokranantaja',
      },
    },
    reports: {
      totalApartments: 'Tilat',
      totalResidents: 'Henkilöt',
      totalCondominiums: 'Kiinteistöt',
    },
    billingAccount: {
      addApartments: 'Lisää tiloja',
      noUnassignedApartments: 'Ei linkittämättömiä tiloja.',
      noLinkedApartments: 'Tähän asiakkuuteen ei ole vielä linkitetty tiloja.',
      linkPropertiesForRelatedLists:
        'Linkitä ensin kiinteistöjä tai tiloja tähän asiakkuuteen, jotta voit selata niihin liittyviä tietoja.',
    },
    billing: {
      auditCondominium: 'Kiinteistöt',
      auditApartment: 'Tilat',
      auditResident: 'Henkilöt',
      auditKey: 'Avaimet',
      colCondominium: 'Kiinteistö',
      colApartment: 'Tila',
    },
    landlordPortal: {
      allApartmentsOption: 'Kaikki tilat',
    },
    residentNotifications: {
      tabTitle: 'Henkilöilmoitukset',
      createTitle: 'Uusi henkilöilmoitus',
      editTitle: 'Muokkaa henkilöilmoitusta',
      empty: 'Ei henkilöilmoituksia',
      deleteTitle: 'Poista henkilöilmoitus',
      scope: {
        wholeCondominium: 'Koko kiinteistö',
        apartmentCount: '{{count}} tilaa',
      },
      field: {
        wholeCondominium: 'Koko kiinteistö',
        wholeCondominiumHelp: 'Ilmoitus näkyy kaikille kiinteistön tiloille henkilö- ja vuokranantajaportaalissa.',
        apartments: 'Valitut tilat',
      },
      validation: {
        apartments: 'Valitse vähintään yksi tila tai koko kiinteistö.',
      },
      portalTitle: 'Henkilöilmoitukset',
    },
    maintenance: {
      repairHistory: {
        selectCondominiumFilter: 'Valitse kiinteistö suodattaaksesi listaa.',
      },
      needsAssessment: {
        selectCondominium: 'Valitse kiinteistö suodattaaksesi listaa.',
      },
    },
    upkeep: {
      allApartments: 'Kaikki tilat',
      filterApartments: 'Suodata tiloja',
      filterApartmentsPlaceholder: 'Kirjoita nimi, osoite tai tila',
      createApartmentInspections: 'Luo tilakohtaiset tarkastukset',
      selectCondominiums: 'Valitse kiinteistöt',
      multiBatchAllApartmentsHelp: 'Jokaiseen valittuun kiinteistöön luodaan rivit kaikille tiloille.',
      filterCondominiums: 'Suodata kiinteistöjä',
      filterCondominiumsPlaceholder: 'Kirjoita kiinteistön nimi tai osoite',
      sendResidentNotification: 'Lähetä henkilöilmoitus',
      sendResidentNotificationHelp:
        'Sama ilmoitus lähetetään valittujen kiinteistöjen henkilöille (ja näkyy portaaleissa).',
      batchCreatedWithNotification: 'Kunnossapito luotu ({{count}} riviä) ja henkilöilmoitus lähetetty',
      multiBatchCreatedWithNotification:
        'Luotiin {{batches}} kunnossapitokokonaisuutta ({{count}} riviä) ja {{notices}} henkilöilmoitusta',
      wizardStepLocationHelp:
        'Valitse kiinteistö ja tarvittaessa tila. Jos tilaa ei valita, voit valita useita tiloja kerralla.',
      wizardStepLocationHelpEquipment:
        'Valitse kiinteistö ja tarvittaessa tila. Jos tilaa ei valita, valitset tilat seuraavassa vaiheessa laitteiden kanssa.',
      locationProperty: 'Kiinteistö',
      locationSpace: 'Tila',
      trackedAssetsHelpSingleApartment: 'Tarkastetaan tämän tilan laitteet. Yksi tehtävä, yksi raportti.',
      trackedAssetsHelpSingleApartmentNamed: 'Tarkastetaan tilan {{apartment}} laitteet. Yksi tehtävä, yksi raportti.',
      trackedAssetsScopeApartment: 'Tila: {{apartment}}',
      trackedAssetsHelpMultiApartment:
        'Valitse tilat ja niiden laitteet. Jokaiseen tilaan luodaan oma tarkastus samalla pohjalla.',
      trackedAssetsEmpty: 'Ei laitteita valitulla kiinteistöllä',
      trackedAssetsEmptyApartment: 'Ei laitteita tilassa {{apartment}}',
      trackedAssetsEmptySelectedApartment: 'Ei laitteita valitulla tilalla',
      trackedAssetApartmentFilter: 'Suodata tilalla',
      trackedAssetApartmentFilterAll: 'Kaikki tilat',
      targetApartments: 'Tilat',
      targetApartmentsHelp: 'Valitse tilat, joihin kunnossapito luodaan (yksi raportti per tila).',
      targetApartmentsEquipmentHelp:
        'Valitse tilat, joiden laitteet tarkastetaan. Jokaiseen tilaan syntyy oma raportti.',
      targetApartmentsBatchHelp:
        'Valinnainen: valitse useita tiloja luodaksesi saman tarkastuksen tai huollon jokaiseen.',
      targetApartmentsBatchCountHelp: 'Luodaan {{count}} erillistä tehtävää, yksi per tila.',
      targetApartmentsSelected: '{{count}} tilaa valittu',
      targetApartmentsRequired: 'Valitse vähintään yksi tila',
      selectApartmentsBeforeDevices: 'Valitse ensin tilat, joiden laitteet haluat tarkastaa.',
      noApartmentsForProperty: 'Kiinteistöllä ei ole tiloja',
      batchCreated: 'Luotiin {{count}} kunnossapitoa (yksi per tila)',
    },
    trackedAssets: {
      columnCondominium: 'Kiinteistö',
      filterCondominium: 'Suodata kiinteistö',
      selectCondominium: 'Valitse kiinteistö',
      apartment: 'Tila',
      selectApartment: 'Valitse tila',
      mapEmptyHint: 'Lisää laitteelle kiinteistö tai tila, jossa on osoite.',
      bulkCreateUpkeepSameCondo: 'Valitse vain saman kiinteistön laitteita.',
    },
    rentalBrokerage: {
      apartment: 'Tila',
      resident: 'Henkilö',
      landlord: 'Vuokranantaja',
      createApartment: 'Luo tila',
      createResidentFromApplicant: 'Luo henkilö',
      createResident: 'Luo henkilö',
      createLandlord: 'Luo vuokranantaja',
      residentFromApplicant: 'Luotu / linkitetty hakijasta',
      partyApplicantNeedsResident: 'Hakija: {{name}} — valitse tai luo henkilö',
      applyTitle: 'Hae tilaa',
      applyDescription: 'Täytä hakemuslomake. Kerro yhteystietosi ja taustatietosi tilan hakua varten.',
      applicationReason: 'Tilan haun syy',
      targetKind: {
        apartment: 'Tila',
      },
    },
    residentPortal: {
      filesSectionTitle: 'Tilan ja kiinteistön tiedostot',
      apartment: 'Tila',
      selectApartment: 'Valitse tila...',
    },
  },
};
